export function decodeMaterialLabelCsv(buffer) {
  const utf8Text = new TextDecoder('utf-8').decode(buffer);
  return utf8Text.includes('\uFFFD')
    ? new TextDecoder('gb18030').decode(buffer)
    : utf8Text;
}

export function parseMaterialLabelCsv(text) {
  const normalized = String(text || '').replace(/^\uFEFF/, '').replace(/\r\n?/g, '\n');
  const lines = normalized.split('\n').filter((line, index, list) => line.trim() || index < list.length - 1);
  const rows = [];
  const errors = [];

  if (!lines.length || lines[0].split(',').map(item => item.trim()).join(',') !== 'label,remark') {
    return { rows, errors: [{ row: 1, message: 'CSV表头必须为label,remark' }] };
  }

  lines.slice(1).forEach((line, index) => {
    const row = index + 2;
    const columns = line.split(',');
    if (columns.length !== 2) {
      errors.push({ row, message: 'CSV每行必须包含label和remark两列' });
      return;
    }

    const item = {
      label: columns[0].trim(),
      remark: columns[1].trim(),
    };
    rows.push(item);
    if (!item.label) {
      errors.push({ row, message: '标签不能为空' });
    } else if (item.label.length > 10) {
      errors.push({ row, message: '标签最大长度限制10个字' });
    }
    if (!item.remark) {
      errors.push({ row, message: '标签说明不能为空' });
    }
  });

  if (rows.length > 20) {
    errors.push({ row: null, message: `CSV 数据共${rows.length}条，最多支持20条` });
  }

  return { rows, errors };
}
